'use client';

import type { ProductDisplayData as Product } from '@eliadmin/core/src/api/products/types/product-types';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Navigation, Pagination } from 'swiper/modules';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ProductCard } from '../product/product-card';

export const CategoryProductsSwiper = ({ products }: { products: Product[] }) => {
  return (
    <Swiper
      pagination={true}
      modules={[Pagination, Navigation]}
      className={cn('mySwiper', 'custom-container', 'ea-custom-swiper')}
      spaceBetween={16}
      slidesPerView={1.1}
      breakpoints={{
        1280: {
          slidesPerView: 2.2,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
      }}
    >
      {products.map(product => (
        <SwiperSlide key={product.slug} className="w-full">
          <ProductCard product={product} key={product.slug} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
